import React, { Component } from "react";

import {
  getCookieData,
  removeCookieData,
  remote_url,
} from "../../../utils/CommonFunction";
import { getApi } from "../../../utils/apiHelper";
import { HRMFrontendSidebarPermissions } from "../../../utils/apiRoutes";
import { pendingAbsenceApi } from "../../../utils/pendingAbsenceApi";

import AllianceBusinessLogo from "./AllianceBusinessLogo";
import DashboardTile from "./DashboardTile";
import SubModuleTile from "./SubModuleTile";
import ModuleTile from "./ModuleTile";
import NestedModuleTile from "./NestedModuleTile";
import LogoutTile from "./LogoutTile";

export default class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      user: getCookieData("user_info"),
      pathname: window.location.pathname,
      sidebarPermissions: null,
      user_id: null,
      // Absence Compliance: the staff / approver tiles depend on the user, not on a permission row.
      pendingAbsenceMenu: { live: false, isApprover: false },
    };
  }

  /**
   * Check if user has permissions to access the modules
   * @param {string} moduleName
   * @returns {boolean}
   */
  hasModulePermission = (moduleName) => {
    const { sidebarPermissions } = this.state;
    if (!sidebarPermissions || sidebarPermissions.length === 0) return false;

    return !!sidebarPermissions.find(({ type }) => type === moduleName);
  };

  /**
   * Check if user has permissions to access the sub-modules
   * @param {string} subModuleName
   * @returns {boolean}
   */
  hasSubModulePermission = (subModuleName, moduleName) => {
    const { sidebarPermissions } = this.state;
    if (!sidebarPermissions || sidebarPermissions.length === 0) return false;

    return !!sidebarPermissions.find(
      ({ title, type }) => title === subModuleName && type === moduleName
    );
  };

  logout = () => {
    removeCookieData("user_info");
  };

  checkPathName() {
    const { pathname } = this.state;
    if (pathname.includes("master_data")) {
      return "/master_data";
    }
    if (pathname.includes("setting")) {
      return "/setting";
    }
    if (pathname.includes("benefit")) {
      return "/benefit";
    }
    if (pathname.includes("staff_loan")) {
      return "/staff_loan";
    }
    if (pathname.includes("helpDesk")) {
      return "/helpDesk";
    }
    if (pathname.includes("paySlip")) {
      return "/paySlip";
    }
    if (pathname.includes("SSCReport")) {
      return "/ssc_report";
    }
    if (pathname.includes("staffComplain")) {
      return "/staffComplain";
    }
    if (pathname.includes("leavemanagement")) {
      return "/leavemanagement";
    }
    if (pathname.includes("attendance_leave_report")) {
      return "/attendance_leave_report";
    }
    if (pathname.includes("notification")) {
      return "/notification";
    }
    if (pathname.includes("dashboard")) {
      return "/dashboard";
    }
    if (pathname.includes("employee_salary_report")) {
      return "/payroll_reports";
    }
    if (pathname.includes("employee")) {
      return "/employee_management";
    }
    if (pathname.includes("employment")) {
      return "/employee_management";
    }
    if (pathname.includes("confirmation")) {
      return "/confirmation";
    }
    if (pathname.includes("reports")) {
      return "/reports";
    }
    if (pathname.includes("payroll_calculation")) {
      return "/payroll_calculation";
    }
    if (pathname.includes("incentive")) {
      return "/incentive";
    }
    if (pathname.includes("attendancerelatedreports")) {
      return "/attendancerelatedreports";
    }
    if (pathname.includes("attendance")) {
      return "/attendance";
    }
    if (pathname.includes("payroll")) {
      return "/payroll";
    }
    if (pathname.includes("payroll_reports")) {
      return "/payroll_reports";
    }
    if (pathname.includes("salary_history_report")) {
      return "/payroll_reports";
    }
    if (pathname.includes("payrollReport_with_bankno")) {
      return "/payroll_reports";
    } else return "/dashboard";
  }

  async componentDidMount() {
    const id = localStorage.getItem("user_id");
    this.setState({
      user_id: id,
    });

    this.getPendingAbsenceMenu();

    const sidebarPermissions = sessionStorage.getItem("Sidebar_Permissions");
    if (sidebarPermissions) {
      this.setState({
        sidebarPermissions: JSON.parse(sidebarPermissions),
      });
    } else {
      this.getSidebarPermissions();
    }
  }

  /**
   * Absence Compliance menu state. The Pending Absence tile appears once the feature is live;
   * the approver tile only for people who approve at least one employee. Failures just hide them.
   */
  getPendingAbsenceMenu = async () => {
    try {
      const [mine, approver] = await Promise.all([
        pendingAbsenceApi.get("/mine/count"),
        pendingAbsenceApi.get("/approver/status"),
      ]);
      this.setState({
        pendingAbsenceMenu: {
          live: Boolean(mine && mine.live),
          isApprover: Boolean(approver && approver.is_approver),
        },
      });
    } catch (error) {
      // keep the tiles hidden
    }
  };

  getSidebarPermissions = async () => {
    const { data } = await getApi(
      HRMFrontendSidebarPermissions(this.state.user.designations_id)
    );
    sessionStorage.setItem(
      "Sidebar_Permissions",
      JSON.stringify(data.permissions)
    );
    this.setState({
      sidebarPermissions: data.permissions,
    });
  };

  render() {
    const { pathname, user } = this.state;

    return (
      <div>
        <nav className="navbar-default navbar-static-side">
          <div className="sidebar-collapse sidebar">
            <ul className="nav" id="side-menu">
              <AllianceBusinessLogo />
              <DashboardTile
                selectedPathName={pathname}
                userId={user.user_id}
              />
              {/*########### Setting ########### */}
              <ModuleTile
                title="Setting"
                icon="fas fa-cog sideIcon"
                initialLink="/attendance_policy_setting"
                isActive={this.checkPathName() === "/setting"}
                hideTile={!this.hasModulePermission("Setting")}
              >
                <SubModuleTile
                  title="Attendance Policy"
                  pathName="/attendance_policy_setting"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Attendance Policy", "Setting")
                  }
                />
                <SubModuleTile
                  title="Benefit"
                  pathName="/benefit_setup_setting"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("Benefit", "Setting")}
                />
                <SubModuleTile
                  title="Holiday"
                  pathName="/holiday_setting"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("Holiday", "Setting")}
                />
                <SubModuleTile
                  title="Salary Template"
                  pathName="/salary_template_setting"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Salary Template", "Setting")
                  }
                />
                <SubModuleTile
                  title="SSB Rate"
                  pathName="/ssb_rate_setting"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("SSB Rate", "Setting")}
                />
                <SubModuleTile
                  title="Career Path"
                  pathName="/career_path_setting"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Career Path", "Setting")
                  }
                />
                <SubModuleTile
                  title="Payroll"
                  pathName="/payroll_setting"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("Payroll", "Setting")}
                />
                <SubModuleTile
                  title="Petrol Amount"
                  pathName="/petrol_amount_setting"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("Petrol Amount", "Setting")}
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Master Data ########### */}
              <ModuleTile
                title="Master Data"
                icon="fa fa-key sideIcon"
                initialLink="/career_level_master_data"
                isActive={this.checkPathName() === "/master_data"}
                hideTile={!this.hasModulePermission("Master Data")}
              >
                <SubModuleTile
                  title="Career Level"
                  pathName="/career_level_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Career Level", "Master Data")
                  }
                />
                <SubModuleTile
                  title="Career Sub Level"
                  pathName="/career_sub_level_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Career Sub Level",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Designations"
                  pathName="/designations_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Designations", "Master Data")
                  }
                />
                <SubModuleTile
                  title="Departments"
                  pathName="/departments_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Departments", "Master Data")
                  }
                />
                <SubModuleTile
                  title="Job Role"
                  pathName="/job_role_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Job Title", "Master Data")
                  }
                />
                <SubModuleTile
                  title="Leave Category"
                  pathName="/leave_category_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Leave Category",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Attendance Reason Type"
                  pathName="/attendance_reason_type_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Attendance Reason Type",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Hospitalization Type"
                  pathName="/hospitalization_type_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Hospitalization Type",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Ticket Main Category"
                  pathName="/ticket_main_category_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Ticket Main Category",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Ticket Sub Category"
                  pathName="/ticket_sub_category_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Ticket Sub Category",
                      "Master Data"
                    )
                  }
                />
                <SubModuleTile
                  title="Tax Range"
                  pathName="/tax_rage_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Tax Rage", "Master Data")
                  }
                />
                <SubModuleTile
                  title="Tax Relief"
                  pathName="/tax_relief_master_data"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Tax Relief", "Master Data")
                  }
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Employee Management ########### */}
              <ModuleTile
                title="Employee Management"
                icon="fas fa-user-cog"
                initialLink={
                  this.hasSubModulePermission(
                    "Employee Lists",
                    "Employee Management"
                  )
                    ? "/employee_list"
                    : this.hasSubModulePermission(
                        "Employment Details",
                        "Employee Management"
                      )
                    ? "/employment_details"
                    : "/EmployeeDirectory"
                }
                isActive={
                  this.checkPathName() === "/employee_management" ||
                  this.checkPathName() === "/reports" ||
                  pathname === "/EmployeeDirectory" ||
                  pathname === "/ResignStaffReport" ||
                  pathname === "/RegionStaffReport" ||
                  pathname === "/BranchStaffReport" ||
                  pathname === "/HoStaffReport" ||
                  pathname === "/EmployeeReport" ||
                  pathname === "/ReportbyServiceYear" ||
                  pathname === "/HistoryReport" ||
                  pathname === "/FRDReport" ||
                  pathname === "/hr_statistic" ||
                  pathname === "/RegionWiseStaffReportCount"
                }
                hideTile={
                  !(
                    this.hasModulePermission("Employee Management") ||
                    this.hasModulePermission("Employee Related Reports")
                  )
                }
              >
                <SubModuleTile
                  title="Employee Lists"
                  pathName="/employee_list"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Employee Lists",
                      "Employee Management"
                    )
                  }
                />
                <SubModuleTile
                  title="Employment Details"
                  pathName="/employment_details"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Employment Details",
                      "Employee Management"
                    )
                  }
                />
                <NestedModuleTile
                  title="Employee Related Reports"
                  initialLink="/reports"
                  isActive={
                    this.checkPathName() === "/reports" ||
                    pathname === "/EmployeeDirectory" ||
                    pathname === "/ResignStaffReport" ||
                    pathname === "/hr_statistic" ||
                    pathname === "/RegionStaffReport" ||
                    pathname === "/BranchStaffReport" ||
                    pathname === "/HoStaffReport" ||
                    pathname === "/EmployeeReport" ||
                    pathname === "/ReportbyServiceYear" ||
                    pathname === "/HistoryReport" ||
                    pathname === "/FRDReport" ||
                    pathname === "/report_confirm"
                  }
                  hideTile={
                    !this.hasModulePermission("Employee Related Reports")
                  }
                >
                  <SubModuleTile
                    title="Employee Report"
                    pathName="/EmployeeReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Employee Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Employee Report by Service Year"
                    pathName="/ReportbyServiceYear"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Employee Report by Service Year",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Employee History Report"
                    pathName="/HistoryReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Employee History Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Employee Directory Report"
                    pathName="/EmployeeDirectory"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Employee Directory Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Ho Staff Report"
                    pathName="/HoStaffReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "HO Staff Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Branch Staff Report"
                    pathName="/BranchStaffReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Branch Staff Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Regional Staff Report"
                    pathName="/RegionStaffReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Regional Staff Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="FRD Report"
                    pathName="/FRDReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "FRD Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Resign Staff Report"
                    pathName="/ResignStaffReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Resign Staff Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Region Wise Staff Count Report"
                    pathName="/RegionWiseStaffReportCount"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Region Wise Staff Count Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="HR Statistic Report"
                    pathName="/hr_statistic"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "HR Statistic Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                </NestedModuleTile>
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Confirmation ########### */}
              {/* <ModuleTile
                title="Confirmation"
                icon="fas fa-user-check"
                initialLink="/confirmation_initiation"
                isActive={
                  this.checkPathName() === "/confirmation" ||
                  pathname === "/extension_report"
                }
                hideTile={
                  !(
                    this.hasModulePermission("Confirmation") ||
                    this.hasModulePermission("Confirmation Reports")
                  )
                }
              >
                <SubModuleTile
                  title="Confirmation Initiation"
                  pathName="/confirmation_initiation"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Confirmation Initiation",
                      "Confirmation"
                    )
                  }
                />
                <SubModuleTile
                  title="Confirmation Request"
                  pathName="/confirmation_request"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Confirmation Request",
                      "Confirmation"
                    )
                  }
                />
                <SubModuleTile
                  title="Final Approval"
                  pathName="/confirmation_final_approval"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Final Approval",
                      "Confirmation"
                    )
                  }
                />
                <NestedModuleTile
                  title="Confirmation Reports"
                  initialLink="/confirmation_history"
                  isActive={
                    pathname === "/confirmation_history" ||
                    pathname === "/extension_report"
                  }
                  hideTile={!this.hasModulePermission("Confirmation Reports")}
                >
                  <SubModuleTile
                    title="Confirmation History"
                    pathName="/confirmation_history"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Confirmation History",
                        "Confirmation Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Extension Report"
                    pathName="/extension_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Extension Report",
                        "Confirmation Reports"
                      )
                    }
                  />
                </NestedModuleTile>
              </ModuleTile> */}
              {/* ------------------------------------------------------------------- */}
              {/*########### Confirmation Old ########### */}
              <ModuleTile
                title="Confirmation"
                icon="fas fa-user-check"
                initialLink="/confirmation_list"
                isActive={
                  this.checkPathName() === "/confirmation" ||
                  this.checkPathName === "/confirmation_reports" ||
                  pathname === "/ExtensionReport" ||
                  pathname === "/report_confirm"
                }
                hideTile={
                  !(
                    this.hasModulePermission("Confirmation List") ||
                    this.hasModulePermission("Employee Related Reports")
                  )
                }
              >
                <SubModuleTile
                  title="Confirmation Prepare List"
                  pathName="/confirmation_list"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Comfirmation Prepare List",
                      "Confirmation List"
                    )
                  }
                />
                <SubModuleTile
                  title="Confirmation Request List"
                  pathName="/confirmation_check"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Confirm List",
                      "Confirmation List"
                    )
                  }
                />
                <SubModuleTile
                  title="Approve List"
                  pathName="/confirmation_approve_list"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Approve List",
                      "Confirmation List"
                    )
                  }
                />
                <NestedModuleTile
                  title="Confirmation Related Reports"
                  initialLink="/confirmation_reports"
                  isActive={
                    this.checkPathName() === "/confirmation_reports" ||
                    pathname === "/ExtensionReport" ||
                    pathname === "/report_confirm"
                  }
                  hideTile={
                    !this.hasModulePermission("Employee Related Reports")
                  }
                >
                  <SubModuleTile
                    title="Extension Report"
                    pathName="/ExtensionReport"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Extension Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Confirmation Report"
                    pathName="/report_confirm"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Confirmation Report",
                        "Employee Related Reports"
                      )
                    }
                  />
                </NestedModuleTile>
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Attendance ########### */}
              <ModuleTile
                title="Attendance"
                icon="fa fa-address-book"
                initialLink="/attendance_type"
                isActive={
                  this.checkPathName() === "/attendance" ||
                  pathname === "/incomplete_and_missing_report" ||
                  pathname === "/holiday_attendance" ||
                  pathname === "/attendance_report_monthly" ||
                  pathname === "/attendance_type" ||
                  pathname === "/attendance_history" ||
                  pathname === "/late_reportby_employee" ||
                  pathname === "/late_checkin_report" ||
                  pathname === "/early_checkout_report" ||
                  pathname === "/absence_report" ||
                  pathname === "/pending_absence" ||
                  pathname === "/pending_absence_request" ||
                  pathname === "/pending_absence_hr" ||
                  pathname === "/attendance_exemption" ||
                  pathname === "/weekly_attendance_report" ||
                  pathname === "/holiday_attendance_report" ||
                  pathname === "/loc_qr"
                }
                hideTile={false} // Because of some sub-modules always shown
              >
                <SubModuleTile
                  title="Check In/Check Out"
                  pathName="/attendance_add"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Check In Check Out",
                      "Attendance"
                    )
                  }
                />
                {/* <SubModuleTile
                  title="LocQR"
                  pathName="/loc_qr"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                /> */}
                <SubModuleTile
                  title="Attendance Request"
                  pathName="/attendance_type"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Attendance History"
                  pathName="/attendance_history"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Pending Absence"
                  pathName="/pending_absence"
                  selectedPathName={pathname}
                  hideTile={!this.state.pendingAbsenceMenu.live}
                />
                <SubModuleTile
                  title="Pending Absence Request"
                  pathName="/pending_absence_request"
                  selectedPathName={pathname}
                  hideTile={
                    !this.state.pendingAbsenceMenu.live ||
                    !this.state.pendingAbsenceMenu.isApprover
                  }
                />
                <SubModuleTile
                  title="Pending Absence (HR)"
                  pathName="/pending_absence_hr"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Pending Absence HR", "Attendance")
                  }
                />
                <SubModuleTile
                  title="Attendance Exemption"
                  pathName="/attendance_exemption"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Attendance Exemption", "Attendance")
                  }
                />
                <SubModuleTile
                  title="Incomplete And Missing Report"
                  pathName="/incomplete_and_missing_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Incomplete And Missing Report",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Holiday Attendance"
                  pathName="/holiday_attendance"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Holiday Attendance",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Attendance Report"
                  pathName="/attendance_report_monthly"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Attendance Report",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Late Report By Employee"
                  pathName="/late_reportby_employee"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Late Report By Employee",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Late Check In Report"
                  pathName="/late_checkin_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Late Check In Report",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Early Check Out Report"
                  pathName="/early_checkout_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Early Check Out Report",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Absence Report"
                  pathName="/absence_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Absence Report", "Attendance")
                  }
                />
                <SubModuleTile
                  title="Weekly Attendance Report"
                  pathName="/weekly_attendance_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Weekly Attendance Report",
                      "Attendance"
                    )
                  }
                />
                <SubModuleTile
                  title="Holiday Attendance Report"
                  pathName="/holiday_attendance_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Holiday Attendance Report",
                      "Attendance"
                    )
                  }
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Payroll ########### */}
              <ModuleTile
                title="Payroll"
                icon="fa fa-address-book"
                initialLink="/ssc"
                isActive={
                  this.checkPathName() === "/payroll" ||
                  this.checkPathName() === "/incentive" ||
                  this.checkPathName() === "payroll_calculation" ||
                  this.checkPathName() === "/payroll_reports" ||
                  this.checkPathName() === "/pay_slip" ||
                  pathname === "/payslip_generate" ||
                  pathname === "/ssc" ||
                  pathname === "/payroll_main" ||
                  pathname === "/foreigner_salary" ||
                  pathname === "/resign_or_dismiss_salary" ||
                  pathname === "/backpay" ||
                  pathname === "/payroll_generate" ||
                  pathname === "/payroll_pay_slip" ||
                  pathname === "/monthly_incentive" ||
                  pathname === "/quarterly_incentive_payslip" ||
                  pathname === "/monthly_incentive_payslip" ||
                  pathname === "/quarterly_incentive" ||
                  pathname === "/employee_salary_report" ||
                  pathname === "/monthly_report" ||
                  pathname === "/quarterly_report" ||
                  pathname === "/ssc_report"
                }
                hideTile={
                  !(
                    this.hasModulePermission("Payroll") ||
                    this.hasModulePermission("Payroll Related Reports")
                  )
                }
              >
                <SubModuleTile
                  title="SSC Calculation"
                  pathName="/ssc"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("SSC Calculation", "Payroll")
                  }
                />
                <NestedModuleTile
                  title="Payroll Calculation"
                  initialLink="/payroll_calculation"
                  isActive={
                    this.checkPathName() === "/payroll_calculation" ||
                    pathname === "/payroll_main" ||
                    pathname === "/payslip_generate" ||
                    pathname === "/payroll_generate"
                  }
                  hideTile={
                    !this.hasSubModulePermission(
                      "Payroll Calculation",
                      "Payroll"
                    )
                  }
                >
                  <SubModuleTile
                    title="Payroll"
                    pathName="/payroll_main"
                    selectedPathName={pathname}
                    hideTile={false} // If Nested Module can be seen, all sub-modules can also be seen
                  />
                  <SubModuleTile
                    title="PaySlip Generate"
                    pathName="/payslip_generate"
                    selectedPathName={pathname}
                    hideTile={false} // If Nested Module can be seen, all sub-modules can also be seen
                  />
                  <SubModuleTile
                    title="Payroll Generate"
                    pathName="/payroll_generate"
                    selectedPathName={pathname}
                    hideTile={false} // If Nested Module can be seen, all sub-modules can also be seen
                  />
                </NestedModuleTile>
                <NestedModuleTile
                  title="Incentive"
                  initialLink="/incentive"
                  isActive={
                    this.checkPathName() === "/incentive" ||
                    pathname === "/monthly_incentive" ||
                    pathname === "/quarterly_incentive"
                  }
                  hideTile={
                    !this.hasSubModulePermission("Incentive", "Payroll")
                  }
                >
                  <SubModuleTile
                    title="Monthly Incentive"
                    pathName="/monthly_incentive"
                    selectedPathName={pathname}
                    hideTile={false} // If Nested Module can be seen, all sub-modules can also be seen
                  />
                  <SubModuleTile
                    title="Quarterly Incentive"
                    pathName="/quarterly_incentive"
                    selectedPathName={pathname}
                    hideTile={false} // If Nested Module can be seen, all sub-modules can also be seen
                  />
                </NestedModuleTile>
                <SubModuleTile
                  title="Resign Or Dismiss Salary"
                  pathName="/resign_or_dismiss_salary"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Resign Or Dismiss Salary",
                      "Payroll"
                    )
                  }
                />
                <SubModuleTile
                  title="Foreigner Salary"
                  pathName="/foreigner_salary"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Foreigner Salary", "Payroll")
                  }
                />
                <SubModuleTile
                  title="BackPay"
                  pathName="/backpay"
                  selectedPathName={pathname}
                  hideTile={!this.hasSubModulePermission("BackPay", "Payroll")}
                />
                <NestedModuleTile
                  title="Payroll Related Reports"
                  initialLink="/payroll_reports"
                  isActive={
                    this.checkPathName() === "/payroll_reports" ||
                    pathname === "/payroll_summary_report" ||
                    pathname === "/payroll_details_report" ||
                    pathname === "/ssc_report" ||
                    pathname === "/payroll_summary_report_with_location" ||
                    pathname === "/employee_salary_report" ||
                    pathname === "/salary_history_report" ||
                    pathname === "/payrollReport_with_bankno" ||
                    pathname === "/monthly_report" ||
                    pathname === "/quarterly_report" ||
                    pathname === "/ssc_report"
                  }
                  hideTile={
                    !this.hasModulePermission("Payroll Related Reports")
                  }
                >
                  <SubModuleTile
                    title="SSC Report for Government"
                    pathName="/ssc_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "SSC Report for Goverment",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Payroll Summary Report"
                    pathName="/payroll_summary_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Payroll Summary Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Payroll Details Report"
                    pathName="/payroll_details_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Payroll Details Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Payroll Summary Report With Location"
                    pathName="/payroll_summary_report_with_location"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Payroll Summary Report With Location",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Employee Salary Report"
                    pathName="/employee_salary_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Employee Salary Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Salary History Report"
                    pathName="/salary_history_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Salary History Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Payroll Report With Bank No"
                    pathName="/payrollReport_with_bankno"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Payroll Report With Bank No",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Monthly Incentive Report"
                    pathName="/monthly_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Monthly Incentive Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                  <SubModuleTile
                    title="Quarterly Incentive Report"
                    pathName="/quarterly_report"
                    selectedPathName={pathname}
                    hideTile={
                      !this.hasSubModulePermission(
                        "Quarterly Incentive Report",
                        "Payroll Related Reports"
                      )
                    }
                  />
                </NestedModuleTile>
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Pay Slip ########### */}
              <ModuleTile
                title="Pay Slip"
                icon="fa fa-credit-card-alt"
                initialLink="/pay_slip"
                isActive={
                  this.checkPathName() === "/pay_slip" ||
                  pathname === "/payroll_pay_slip" ||
                  pathname === "/payslip_monthly_incentive" ||
                  pathname === "/payslip_quarterly_incentive"
                }
                hideTile={false} // Everyone can view Pay Slip
              >
                <SubModuleTile
                  title="PayRoll Pay Slip"
                  pathName="/payroll_pay_slip"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Monthly Incentive Pay Slip"
                  pathName="/payslip_monthly_incentive"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Quarterly Incentive Pay Slip"
                  pathName="/payslip_quarterly_incentive"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Leave ########### */}
              <ModuleTile
                title="Leave"
                image="/assets/icons/Leave (1).svg"
                initialLink="/leave_management"
                isActive={
                  this.checkPathName() === "/leavemanagement" ||
                  pathname === "/leave_management" ||
                  pathname === "/leave_report" ||
                  pathname === "/earned_leave_opening_balance" ||
                  pathname === "/attendance_leave_report" ||
                  pathname === "/earned_leave_carry"
                }
                hideTile={!this.hasModulePermission("Leave")}
              >
                <SubModuleTile
                  title="Leave Request"
                  pathName="/leave_management"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Leave Request", "Leave")
                  }
                />
                <SubModuleTile
                  title="Leave Report"
                  pathName="/leave_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Leave Report", "Leave")
                  }
                />
                <SubModuleTile
                  title="Earned Leave Opening Balance"
                  pathName="/earned_leave_opening_balance"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Earned Leave Opening Balance",
                      "Leave"
                    )
                  }
                />
                <SubModuleTile
                  title="Attendance Leave"
                  pathName="/attendance_leave_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Attendance and Leave",
                      "Leave"
                    )
                  }
                />
                <SubModuleTile
                  title="Earned Leave Carry"
                  pathName="/earned_leave_carry"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Earned Leave Carry", "Leave")
                  }
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Benefits ########### */}
              <ModuleTile
                title="Benefits"
                image="/assets/icons/Benefit.svg"
                initialLink="/wedding_benefit"
                isActive={this.checkPathName() === "/benefit"}
                hideTile={false} // Everyone can view benefits
              >
                <SubModuleTile
                  title="Wedding Benefits"
                  pathName="/wedding_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Child Benefit"
                  pathName="/child_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Funeral Benefit"
                  pathName="/funeral_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="External Training"
                  pathName="/external_training_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Medical Benefit"
                  pathName="/medical_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Birthday Fund"
                  pathName="/birthday_fund_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Team Building"
                  pathName="/team_building_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Hospitalization"
                  pathName="/hospitalization_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Cycle Insurance"
                  pathName="/cycle_insurance_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Other Benefit"
                  pathName="/other_benefit"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Allowance ########### */}
              <ModuleTile
                title="Allowance"
                image="/assets/icons/Allowance (1).svg"
                initialLink="/petrol"
                isActive={
                  this.checkPathName() === "/allowance" ||
                  pathname === "/travelRequest" ||
                  pathname === "/trainingRequest" ||
                  pathname === "/salary_advance" ||
                  pathname === "/phonebillrequest" ||
                  pathname === "/petrol"
                }
                hideTile={false} // Everyone can view Allowance
              >
                <SubModuleTile
                  title="Petrol Request"
                  pathName="/petrol"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Travel Request"
                  pathName="/travelRequest"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Training Request"
                  pathName="/trainingRequest"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
                <SubModuleTile
                  title="Salary Advance"
                  pathName="/salary_advance"
                  selectedPathName={pathname}
                  hideTile={false} // Everyone can view
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}
              {/*########### Help Desk ########### */}
              <ModuleTile
                title="Help Desk"
                image="/assets/icons/Helpdesk (1).svg"
                initialLink="/helpDesk"
                isActive={this.checkPathName() === "/helpDesk"}
                hideTile={false} // Everyone can view Help Desk
              />
              {/* ------------------------------------------------------------------- */}
              {/*########### Staff Complain Box ########### */}
              <ModuleTile
                title="Staff Complain Box"
                image="/assets/icons/aa.svg"
                initialLink="/staffComplain"
                isActive={this.checkPathName() === "/staffComplain"}
                hideTile={false} // Everyone can view Staff Complain Box
              />
              {/* ------------------------------------------------------------------- */}
              {/*########### Staff Loan ########### */}
              <ModuleTile
                title="Staff Loan"
                image="/assets/icons/bb.svg"
                initialLink="/staff_loan"
                isActive={
                  this.checkPathName() === "/staff_loan" ||
                  this.checkPathName() === "/staff_loan_before_committee" ||
                  this.checkPathName() === "/staff_loan_approve" ||
                  this.checkPathName() === "/staff_loan_after_committee"
                }
                hideTile={!this.hasModulePermission("Staff Loan")}
              >
                <SubModuleTile
                  title="Staff Loan List"
                  pathName="/staff_loan"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission("Staff Loan", "Staff Loan")
                  }
                />
                <SubModuleTile
                  title="Staff Loan Approve"
                  pathName="/staff_loan_approve"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Staff Loan Approve",
                      "Staff Loan"
                    )
                  }
                />
                <SubModuleTile
                  title="Staff Loan Before Committee Report"
                  pathName="/staff_loan_before_committee"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Staff Loan Before Committee Report",
                      "Staff Loan"
                    )
                  }
                />
                <SubModuleTile
                  title="Staff Loan After Committee Report"
                  pathName="/staff_loan_after_committee"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Staff Loan After Committee Report",
                      "Staff Loan"
                    )
                  }
                />
                <SubModuleTile
                  title="Staff Loan Summary Report"
                  pathName="/staff_loan_summary_report"
                  selectedPathName={pathname}
                  hideTile={
                    !this.hasSubModulePermission(
                      "Staff Loan Summary Report",
                      "Staff Loan"
                    )
                  }
                />
              </ModuleTile>
              {/* ------------------------------------------------------------------- */}

              {/*########### Logout ########### */}
              <LogoutTile
                remote_url={remote_url}
                onLogout={this.logout.bind(this)}
              />
              {/* ------------------------------------------------------------------- */}

              {this.state.user && this.state.user.user_id === 1 ? (
                <li className="">
                  <a href="/workflow" className="sideList" refresh="true">
                    <i className="fa fa-briefcase sideIcon"></i>
                    <span className="sideText">Work Flow</span>
                  </a>
                </li>
              ) : (
                ""
              )}
              {this.state.user && this.state.user.user_id === 1 ? (
                <li className={pathname === "/permission" ? "active" : ""}>
                  <a href="/permission" className="sideList">
                    <i className="fa fa-key sideIcon"></i>
                    <span className="sideText">Permission</span>
                  </a>
                </li>
              ) : (
                ""
              )}
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}
